import React from 'react';
import { useLanguage } from '../../../i18n';

const ResultsFooter = () => {
  const { t } = useLanguage();

  return (
    <>
      <p style={{ textAlign: 'center', fontSize: '0.875rem', color: '#666', marginTop: '1.5rem', marginBottom: '0.5rem' }}>
        {t('resultDisclaimer')}
      </p>
      
      <div style={{
        marginTop: '2rem',
        paddingTop: '1.5rem',
        borderTop: '1px solid #ddd',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '1rem'
      }}>
        <div>
          <img 
            src="/logo-separatus.png"
            alt="separatus Vergleich"
            style={{ height: '40px', objectFit: 'contain' }}
          />
        </div>
        <div style={{ textAlign: 'left' }}>
          <a href="tel:+41715522350" style={{ color: '#333', textDecoration: 'none', display: 'block', marginBottom: '0.25rem', fontSize: '0.9rem' }}>
            ☎ +41 71 552 2350
          </a>
          <a href="mailto:office@separatus.ch" style={{ color: '#333', textDecoration: 'none', display: 'block', fontSize: '0.9rem' }}>
            ✉ office@separatus.ch
          </a>
        </div>
      </div>
      
      <p style={{ textAlign: 'center', fontSize: '0.8rem', color: '#999', marginTop: '1rem', marginBottom: '0' }}>
        &copy; {new Date().getFullYear()} separatus. {t('allRightsReserved')} | separatus-kostenrechner v1.0.0
      </p>
    </>
  );
};

export default ResultsFooter;
